import styled, { keyframes } from 'styled-components';

export const Wrapper = styled.div<{ height?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${p => (p.height ? p.height : '100%')};
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    animation: ${spin} 1s linear infinite;
  }
`;
